import {
  MENU_TITLE,
  ROLES,
  MAIN_INFO,
  SHOW_SPINNER,
  DEFAULT_USER_STATUS,
} from './mutation-types';

export default {

  [MENU_TITLE](state, menuTitle) {
    state.menuTitle = menuTitle;
  },

  [ROLES](state, response) {
    state.roles = response.roles;
  },

  [MAIN_INFO](state, mainInfo) {
    state.mainInfo = mainInfo;
  },

  [SHOW_SPINNER](state, isShow) {
    state.spinnerVisible = isShow
  },
  [DEFAULT_USER_STATUS](state, status) {
    state.defaultUserStatus = status
  },



};
